export default __webpack_public_path__ + "images/PptIcon.3386b37ed9c448868eb4847cc3f4493d.png";